import PatientPage from './Patient.page';

export default PatientPage;
